// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k_6s7{display:flex;flex-direction:column;width:100%}.ZXDzx{width:100%;max-width:420px}.sT0rw{white-space:nowrap}.EjgK2{z-index:1500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `k_6s7`,
	"compact": `ZXDzx`,
	"upcomingBadge": `sT0rw`,
	"calendarPopper": `EjgK2`
};
export default ___CSS_LOADER_EXPORT___;
